import FrontendService from '@/services/frontendService'
const fes = new FrontendService()
const acesso_livre = () => true;
const formatarData = (val)=> new Date(val).toLocaleString();
const formatarDataShort = (val)=> {
                                const data = val.split('-')
                                const y = `${data[0]}`.padStart(4, '0')
                                const m = `${data[1]}`.padStart(2, '0')
                                const d = `${data[2]}`.padStart(2, '0')
                                // new Date(val).format('DD/MM/YYYY')
                                return `${d}/${m}/${y}`
                            };
const truncate = (value, size)=> {
                            if (!value) return '';
                            value = value.toString();
                            if (value.length <= size) return value;
                            return value.substr(0, size)+'...';
                        };
// const is_gestor_secao = () => fes.isGestorSecao();
const is_superuser = ()=> fes.isSuper();
const is_staff = ()=> fes.isStaff();
const has_bis = ()=> fes.has_bis();
const is_atendente = ()=> fes.is_atendente();
const has_perm = (code, considerar_superusuario=true)=> fes.has_perm(code, considerar_superusuario);
const has_group = (code)=> fes.has_group(code);
const is_cit = ()=> fes.has_group('RECURSO_INFRA_S') || fes.has_group ('INTRANET_ADMIN');
// Módulo de Catracas
const pode_cadastrar_idsecure = ()=> fes.has_perm('can_cadastrar_visitante');
const pode_alterar_parametros_alunos = ()=> fes.has_perm('can_alterar_parametro_matricula_alunos');
// Desuso (TODO: Remover)
const pode_consultar_idsecure = ()=> fes.has_perm('can_consultar_visitante')
const pode_remover_idsecure = ()=> fes.has_perm('can_remover_visitante')
const pode_alterar_idsecure = ()=> fes.has_perm('can_alterar_visitante')
const pode_ver_logvisitante = ()=> fes.has_perm('view_logvisitanteidsecure')
const pode_aprovar_solicitacao_visitante = ()=> fes.has_perm('can_aprovar_solicitacao_visitante')
// Módulo de Ativação e Foto de usuários de alunos
const pode_ativar_usuarios_alunos = ()=> fes.has_perm('can_ativar_usuarios_alunos');
const pode_atualizar_foto_alunos = ()=> fes.has_perm('can_atualiza_foto_alunos');
// AgendaLABS
const pode_acessar_agendalabs = (validate=false) => fes.has_perm('can_acessar_agendalabs') || validate ;
const pode_gerenciar_espacos = (validate=false) => fes.has_perm('can_gerenciar_espaco') || validate ;
const pode_cancelar_reservas = (validate=false) => fes.has_perm('can_cancelar_reserva') || validate ;
const pode_aprovar_reservas = (validate=false) => fes.has_perm('can_aprovar_reserva') || validate ;
// Caderno Formando Graduação
const pode_acessar_caderno_formandos = () => fes.has_perm('can_acessar_caderno_formandos', false);
// Caderno Concluintes Pós Graduação
const pode_acessar_caderno_concluintes = () => fes.has_perm('can_acessar_caderno_concluintes', false);
// Enturmação
const pode_enturmar_alunos = () => fes.has_perm('can_enturmar_alunos', false);
// Set Data de Lançamento
const pode_atualizar_data_lancamento = () => fes.has_perm('can_atualizar_data_lancamento', false);
// Set Migração de Bolsas
const pode_migrar_bolsas = () => fes.has_perm('can_migrar_bolsas', false);
// Atualiza Parcela Inicial UNDB
const pode_atualizar_parcela_inicial = () => fes.has_perm('can_atualizar_parcela_inicial', true);
// Set NF Rejeitada
const pode_atualizar_nfe_rejeitada = () => fes.has_perm('can_atualizar_nf_rejeitada', false);
// Campo Prouni Complementar 50%
const pode_atualizar_campo_prouni = () => fes.has_perm('can_atualizar_campo_prouni', false);
//RH
/* Gestor RH */
const eh_gestor_rh = () => fes.has_perm('can_gerenciar_avaliacao', false);
/* Líderes/Gestores */
const eh_lider_avaliador = () => fes.has_perm('can_avaliar_colaborador', false);
/** Colaborador é não Líder e não Gestor */
// const is_colaborador_rh = () => !fes.has_perm('can_avaliar_colaborador', false) && 
//                                 !fes.has_perm('can_gerenciar_avaliacao', false);
/** CHECKLIST DB */
const pode_gerenciar_checklistdb = () => fes.has_perm('can_gerenciar_listas_checklistdb', false);
const pode_criar_listas_checklistdb = () => fes.has_perm('can_gerenciar_listas_checklistdb', false) || 
                                            fes.has_perm('can_criar_lista_checklistdb', false);
const pode_receber_material_checklistdb = () => fes.has_perm('can_gerenciar_listas_checklistdb', false) || 
                                            fes.has_perm('can_receber_material_checklistdb', false);
const pode_entregar_material_checklistdb = () => fes.has_perm('can_gerenciar_listas_checklistdb', false) || 
                                            fes.has_perm('can_entregar_material_checklistdb', false);
const pode_atualizar_financeiro_checklistdb = () => fes.has_perm('can_gerenciar_listas_checklistdb', false) || 
                                            fes.has_perm('can_atualizar_financeiro_checklistdb', false);
/** DASHBOARD */
const pode_visualizar_dashboard = () => fes.has_perm('can_visualiza_dashboard', false);

const functions = {
    formatarData,
    formatarDataShort,
    truncate,
    acesso_livre,
    // is_gestor_secao,
    is_superuser,
    is_staff,
    has_bis,
    is_atendente,
    has_perm,
    has_group,
    is_cit,
    pode_cadastrar_idsecure,
    pode_alterar_parametros_alunos,
    pode_consultar_idsecure,
    pode_remover_idsecure,
    pode_alterar_idsecure,
    pode_ver_logvisitante,
    pode_aprovar_solicitacao_visitante,
    // Módulo de Ativação e Foto de usuários de alunos
    pode_ativar_usuarios_alunos,
    pode_atualizar_foto_alunos,
    // AgendaLABS
    pode_acessar_agendalabs,
    pode_gerenciar_espacos,
    pode_cancelar_reservas,
    pode_aprovar_reservas,
    // Caderno Formando Graduação
    pode_acessar_caderno_formandos,
    // Caderno Concluintes Pós Graduação
    pode_acessar_caderno_concluintes,
    // Enturmação
    pode_enturmar_alunos,
    // Set Data de Lançamento
    pode_atualizar_data_lancamento,
    // Set Data de Lançamento
    pode_atualizar_nfe_rejeitada,
    // Migrar Bolsas Graduação UNDBw
    pode_migrar_bolsas,
    // Atualiza parcela inicial
    pode_atualizar_parcela_inicial,
    // Campo Prouni Complementar 50%
    pode_atualizar_campo_prouni,
    
    //RH
    /* Gestor RH */
    eh_gestor_rh,
    /* Líderes/Gestores */
    eh_lider_avaliador,
    /** Colaborador é não Líder e não Gestor */
    // is_colaborador_rh,
    
    /** CHECKLIST DB */
    pode_gerenciar_checklistdb,
    pode_criar_listas_checklistdb,
    pode_receber_material_checklistdb,
    pode_entregar_material_checklistdb,
    pode_atualizar_financeiro_checklistdb,
    
    /** DASHBOARD */
    pode_visualizar_dashboard,

    // MENUS
    menu_options: [
            {
                route_name:'index',
                icon:'mdi-home',
                title:'Página inicial',
                subtitle:'Início',
                perm: () => acesso_livre()
            },
            {
                route_name:'atendimentos',
                icon:'mdi-face-agent',
                title:'Atendimento',
                subtitle:'Gerenciamento de filas',
                perm: () => is_atendente()
            },
            {
                route_name:'infraestrutura',
                icon:'mdi-application-cog-outline',
                title:'Infraestrutura',
                subtitle:'Recursos Operacionais',
                perm: () => fes.has_perm('view_monitorservico')
            },
            {
                route_name:'agendalabs',
                icon:'mdi-calendar',
                title:'Agenda Labs',
                subtitle:'Agendamento de espaços',
                perm: () => pode_acessar_agendalabs()
            },
            {
                route_name:'checklist-db',
                icon:'mdi-check',
                title:'CheckList DB',
                subtitle:'Recebimento de Materiais Dom Bosco',
                perm: () => pode_gerenciar_checklistdb() ||
                            pode_criar_listas_checklistdb() ||
                            pode_receber_material_checklistdb() ||
                            pode_entregar_material_checklistdb() ||
                            pode_atualizar_financeiro_checklistdb()
            },
            {
                route_name:'catracas',
                icon:'mdi-turnstile',
                title:'Catracas',
                subtitle:'Gerenciamento IDSecure',
                perm: () => fes.has_group('RECURSO_INFRA_S') ||
                                pode_cadastrar_idsecure() ||
                                pode_alterar_parametros_alunos()
            },
            {
                route_name:'moodle-undb',
                icon:'mdi-school',
                title:'UNDB Classroom',
                subtitle:'Moodle UNDB',
                perm: () => fes.has_perm('can_integrate_undbclassroom') ||
                            fes.has_perm('can_resetpassword_undbclassroom')
            },
            {
                route_name:'moodle-undb-pos',
                icon:'mdi-school',
                title:'UNDB Pós',
                subtitle:'Moodle UNDB Pós',
                perm: () => fes.has_perm('can_resetpassword_undbpos')
            },
            {
                route_name:'rm',
                icon:'mdi-checkbox-blank-badge',
                title:'TOTVS RM',
                subtitle:'Recursos do RM',
                perm: () => acesso_livre()
            },
            {
                route_name:'bi-repositorio',
                icon:'mdi-puzzle-outline',
                title:'Repositório Dados',
                subtitle:'Repositório de fonte de dados externas',
                perm: () => has_bis()
            },
            {
                route_name:'dashboard',
                icon:'mdi-chart-line',
                title:'Dashboard',
                subtitle:'Gráficos',
                perm: () => pode_visualizar_dashboard()
            },
            {
                route_name:'wiki',
                icon:'mdi-book-search',
                title:'Repositório Documentos',
                subtitle:'Base de conhecimento',
                perm: () => fes.has_perm('view_wiki')
            },
            {
                route_name:'rh',
                icon:'mdi-account-group',
                title:'Gente e Gestão',
                subtitle:'Ambiente Gente e Gestão',
                perm: () => eh_gestor_rh() || eh_lider_avaliador() || fes.has_perm('can_acessar_avaliacao_tempo_casa', false)
            }
    ],

    user_filiais: (authUser)=> {
        if (authUser && (authUser.get_filiais||[]).length > 0){
            let ufs = authUser.get_filiais
            return ufs
        }
        return []
    },
    calcula_luminescencia: (hexColor)=>{
            // Remove o símbolo # se estiver presente
            if (hexColor.startsWith('#')) {
                hexColor = hexColor.slice(1);
            }
        
            // Converte o valor hexadecimal para valores RGB
            let r = parseInt(hexColor.substr(0, 2), 16);
            let g = parseInt(hexColor.substr(2, 2), 16);
            let b = parseInt(hexColor.substr(4, 2), 16);
        
            // Normaliza os valores RGB
            r /= 255;
            g /= 255;
            b /= 255;
        
            // Calcula a luminância relativa
            let luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        
            // Define a cor do texto com base na luminância
            return luminance > 0.5 ? 'black' : 'white';
    },
    links_uteis: [
        {
            label: 'Portal Professor (novo)',
            link: 'https://portal.undb.edu.br/FrameHTML/Web/App/Edu/PortalDoProfessor/#/login',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Portal Professor (antigo)',
            link: 'https://portal.undb.edu.br/Corpore.Net/Login.aspx',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Portal Aluno - UNDB',
            link: 'https://portal.undb.edu.br/framehtml/web/app/edu/portaleducacional/login/',
            categoria: 'Acadêmicos'
        },
        {
            label: 'RAC PIX - GDB',
            link: 'https://grupodomboscoltda.rac.totvs.app/totvs.rac/Account/Login',
            categoria: 'Interno'
        },
        {
            label: 'Educa Mobile',
            link: 'https://portal.undb.edu.br/EducaMobile/Account/Login',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Portal Aluno - DB',
            link: 'https://portal.dbosco.com.br/framehtml/web/app/edu/portaleducacional/login/',
            categoria: 'Acadêmicos'
        },
        {
            label: 'UNDB Classroom',
            link: 'https://undbclassroom.undb.edu.br/',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Periódicos UNDB',
            link: 'https://periodicos.undb.edu.br/',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Eventos Odonto UNDB',
            link: 'https://eventos.undb.edu.br/',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Esterilização',
            link: 'https://odonto.undb.edu.br/',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Minha Biblioteca',
            link: 'https://dliportal.zbra.com.br/Login.aspx?key=UNDB',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Acervo Biblioteca',
            link: 'http://biblioteca.undb.edu.br:8080/scbweb/acervo.php',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Eventos - App DB',
            link: 'https://appdb.dbosco.com.br/eventos',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Abertura de Chamados',
            link: 'http://suporte.dbosco.com.br/',
            categoria: 'Interno'
        },
        {
            label: 'Serviços GDB',
            link: 'https://servicos.undb.edu.br/',
            categoria: 'Interno'
        },
        {
            label: 'Air Notifier',
            link: 'https://undbclassnotifier.undb.edu.br:4443/',
            categoria: 'Interno'
        },
        {
            label: 'SGA Odontologia',
            link: 'https://sgaodonto.undb.edu.br/sga/public',
            categoria: 'Interno'
        },
        {
            label: 'SGA Central UNDB',
            link: 'https://atendimento.undb.edu.br/undb/public/login',
            categoria: 'Interno'
        },
        {
            label: 'F5 Exponencial',
            link: 'http://f5exponencial.undb.edu.br/',
            categoria: 'Interno'
        },
        {
            label: 'Gestão Educacional',
            link: 'https://portal.undb.edu.br/FrameHTML/web/app/edu/PortalGestaoEducacional/',
            categoria: 'Interno'
        },
        {
            label: 'Portal Meu RH',
            link: 'https://portal.undb.edu.br/framehtml/web/app/RH/PortalMeuRH/#/login',
            categoria: 'Interno'
        },
        {
            label: 'Agenda Labs Saúde',
            link: 'https://labsaude.undb.edu.br/',
            categoria: 'Interno'
        },
        {
            label: 'Fluig',
            link: 'http://portal.undb.edu.br:8080/portal/home',
            categoria: 'Interno'
        },
        {
            label: 'Visitas Dom Bosco',
            link: 'https://home.dbosco.com.br/',
            categoria: 'Externo'
        },
        {
            label: 'Sou UNDB',
            link: 'http://sou.undb.edu.br/',
            categoria: 'Externo'
        },
        {
            label: 'Repositório TCC',
            link: 'http://repositorio.undb.edu.br/',
            categoria: 'Acadêmicos'
        },
        {
            label: 'Lupi E-commerce',
            link: 'https://lupi.dbosco.com.br/',
            categoria: 'Externo'
        },
    ],
    lista_cores_hex:[
        { name: 'Black', hexa: '#000000' },
        { name: 'grey11', hexa: '#1C1C1C' },
        { name: 'grey21', hexa: '#363636' },
        { name: 'grey31', hexa: '#4F4F4F' },
        { name: 'DimGray', hexa: '#696969' },
        { name: 'Gray', hexa: '#808080' },
        { name: 'DarkGray', hexa: '#A9A9A9' },
        { name: 'Silver', hexa: '#C0C0C0' },
        { name: 'LightGrey', hexa: '#D3D3D3' },
        { name: 'Gainsboro', hexa: '#DCDCDC' },
        { name: 'SlateBlue', hexa: '#6A5ACD' },
        { name: 'SlateBlue1', hexa: '#836FFF' },
        { name: 'SlateBlue3', hexa: '#6959CD' },
        { name: 'DarkSlateBlue', hexa: '#483D8B' },
        { name: 'MidnightBlue', hexa: '#191970' },
        { name: 'Navy', hexa: '#000080' },
        { name: 'DarkBlue', hexa: '#00008B' },
        { name: 'MediumBlue', hexa: '#0000CD' },
        { name: 'Blue', hexa: '#0000FF' },
        { name: 'CornflowerBlue', hexa: '#6495ED' },
        { name: 'RoyalBlue', hexa: '#4169E1' },
        { name: 'DodgerBlue', hexa: '#1E90FF' },
        { name: 'DeepSkyBlue', hexa: '#00BFFF' },
        { name: 'LightSkyBlue', hexa: '#87CEFA' },
        { name: 'SkyBlue', hexa: '#87CEEB' },
        { name: 'LightBlue', hexa: '#ADD8E6' },
        { name: 'SteelBlue', hexa: '#4682B4' },
        { name: 'LightSteelBlue', hexa: '#B0C4DE' },
        { name: 'SlateGray', hexa: '#708090' },
        { name: 'LightSlateGray', hexa: '#778899' },
        { name: 'Aqua', hexa: '#00FFFF' },
        { name: 'DarkTurquoise', hexa: '#00CED1' },
        { name: 'Turquoise', hexa: '#40E0D0' },
        { name: 'MediumTurquoise', hexa: '#48D1CC' },
        { name: 'LightSeaGreen', hexa: '#20B2AA' },
        { name: 'DarkCyan', hexa: '#008B8B' },
        { name: 'Teal', hexa: '#008080' },
        { name: 'Aquamarine', hexa: '#7FFFD4' },
        { name: 'MediumAquamarine', hexa: '#66CDAA' },
        { name: 'CadetBlue', hexa: '#5F9EA0' },
        { name: 'DarkSlateGray', hexa: '#2F4F4F' },
        { name: 'MediumSpringGreen', hexa: '#00FA9A' },
        { name: 'SpringGreen', hexa: '#00FF7F' },
        { name: 'PaleGreen', hexa: '#98FB98' },
        { name: 'LightGreen', hexa: '#90EE90' },
        { name: 'DarkSeaGreen', hexa: '#8FBC8F' },
        { name: 'MediumSeaGreen', hexa: '#3CB371' },
        { name: 'SeaGreen', hexa: '#2E8B57' },
        { name: 'DarkGreen', hexa: '#006400' },
        { name: 'Green', hexa: '#008000' },
        { name: 'ForestGreen', hexa: '#228B22' },
        { name: 'LimeGreen', hexa: '#32CD32' },
        { name: 'Lime', hexa: '#00FF00' },
        { name: 'LawnGreen', hexa: '#7CFC00' },
        { name: 'Chartreuse', hexa: '#7FFF00' },
        { name: 'GreenYellow', hexa: '#ADFF2F' },
        { name: 'YellowGreen', hexa: '#9ACD32' },
        { name: 'OliveDrab', hexa: '#6B8E23' },
        { name: 'DarkOliveGreen', hexa: '#556B2F' },
        { name: 'Olive', hexa: '#808000' },
        { name: 'DarkKhaki', hexa: '#BDB76B' },
        { name: 'Goldenrod', hexa: '#DAA520' },
        { name: 'DarkGoldenrod', hexa: '#B8860B' },
        { name: 'SaddleBrown', hexa: '#8B4513' },
        { name: 'Sienna', hexa: '#A0522D' },
        { name: 'RosyBrown', hexa: '#BC8F8F' },
        { name: 'Peru', hexa: '#CD853F' },
        { name: 'Chocolate', hexa: '#D2691E' },
        { name: 'SandyBrown', hexa: '#F4A460' },
        { name: 'NavajoWhite', hexa: '#FFDEAD' },
        { name: 'Wheat', hexa: '#F5DEB3' },
        { name: 'BurlyWood', hexa: '#DEB887' },
        { name: 'Tan', hexa: '#D2B48C' },
        { name: 'MediumSlateBlue', hexa: '#7B68EE' },
        { name: 'MediumPurple', hexa: '#9370DB' },
        { name: 'BlueViolet', hexa: '#8A2BE2' },
        { name: 'Indigo', hexa: '#4B0082' },
        { name: 'DarkViolet', hexa: '#9400D3' },
        { name: 'DarkOrchid', hexa: '#9932CC' },
        { name: 'MediumOrchid', hexa: '#BA55D3' },
        { name: 'Purple', hexa: '#A020F0' },
        { name: 'DarkMagenta', hexa: '#8B008B' },
        { name: 'Fuchsia', hexa: '#FF00FF' },
        { name: 'Violet', hexa: '#EE82EE' },
        { name: 'Orchid', hexa: '#DA70D6' },
        { name: 'Plum', hexa: '#DDA0DD' },
        { name: 'MediumVioletRed', hexa: '#C71585' },
        { name: 'DeepPink', hexa: '#FF1493' },
        { name: 'HotPink', hexa: '#FF69B4' },
        { name: 'PaleVioletRed', hexa: '#DB7093' },
        { name: 'LightPink', hexa: '#FFB6C1' },
        { name: 'Pink', hexa: '#FFC0CB' },
        { name: 'LightCoral', hexa: '#F08080' },
        { name: 'IndianRed', hexa: '#CD5C5C' },
        { name: 'Crimson', hexa: '#DC143C' },
        { name: 'Maroon', hexa: '#800000' },
        { name: 'DarkRed', hexa: '#8B0000' },
        { name: 'FireBrick', hexa: '#B22222' },
        { name: 'Brown', hexa: '#A52A2A' },
        { name: 'Salmon', hexa: '#FA8072' },
        { name: 'DarkSalmon', hexa: '#E9967A' },
        { name: 'LightSalmon', hexa: '#FFA07A' },
        { name: 'Coral', hexa: '#FF7F50' },
        { name: 'Tomato', hexa: '#FF6347' },
        { name: 'Red', hexa: '#FF0000' },
        { name: 'OrangeRed', hexa: '#FF4500' },
        { name: 'DarkOrange', hexa: '#FF8C00' },
        { name: 'Orange', hexa: '#FFA500' },
        { name: 'Gold', hexa: '#FFD700' },
        { name: 'Yellow', hexa: '#FFFF00' },
        { name: 'Khaki', hexa: '#F0E68C' },
        { name: 'AliceBlue', hexa: '#F0F8FF' },
        { name: 'GhostWhite', hexa: '#F8F8FF' },
        { name: 'Snow', hexa: '#FFFAFA' },
        { name: 'Seashell', hexa: '#FFF5EE' },
        { name: 'FloralWhite', hexa: '#FFFAF0' },
        { name: 'WhiteSmoke', hexa: '#F5F5F5' },
        { name: 'Beige', hexa: '#F5F5DC' },
        { name: 'OldLace', hexa: '#FDF5E6' },
        { name: 'Ivory', hexa: '#FFFFF0' },
        { name: 'Linen', hexa: '#FAF0E6' },
        { name: 'Cornsilk', hexa: '#FFF8DC' },
        { name: 'AntiqueWhite', hexa: '#FAEBD7' },
        { name: 'BlanchedAlmond', hexa: '#FFEBCD' },
        { name: 'Bisque', hexa: '#FFE4C4' },
        { name: 'LightYellow', hexa: '#FFFFE0' },
        { name: 'LemonChiffon', hexa: '#FFFACD' },
        { name: 'LightGoldenrodYellow', hexa: '#FAFAD2' },
        { name: 'PapayaWhip', hexa: '#FFEFD5' },
        { name: 'PeachPuff', hexa: '#FFDAB9' },
        { name: 'Moccasin', hexa: '#FFE4B5' },
        { name: 'PaleGoldenrod', hexa: '#EEE8AA' },
        { name: 'MistyRose', hexa: '#FFE4E1' },
        { name: 'LavenderBlush', hexa: '#FFF0F5' },
        { name: 'Lavender', hexa: '#E6E6FA' },
        { name: 'Thistle', hexa: '#D8BFD8' },
        { name: 'Azure', hexa: '#F0FFFF' },
        { name: 'LightCyan', hexa: '#E0FFFF' },
        { name: 'PowderBlue', hexa: '#B0E0E6' },
        { name: 'PaleTurquoise', hexa: '#E0FFFF' },
        { name: 'Honeydew', hexa: '#F0FFF0' },
        { name: 'MintCream', hexa: '#F5FFFA' },

    ]
};
export default functions